import Image from 'next/image';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import notFoundSvg from './not-found.svg?url';

import { Typography } from '@/components/ui/typography/typography.component';
import { Button } from '@/components/ui/button/button.component';
import { ContentContainer } from '@/components/ui/content-container.component';
import { Card } from '@/components/ui/card.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';

export interface EmptyStateProps {
  description: string;
  title: string;
  button: {
    label: string;
    href: string;
  };
}

export default function EmptyState({ title, description, button }: EmptyStateProps) {
  return (
    <div className="w-full bg-color-grey-100 flex items-center justify-center sm:my-10 px-100">
      <ContentContainer className="md:mt-6 sm:my-10 px-0">
        <Card className="max-w-xl mx-auto border-none rounded-2xl sm:shadow-floating py-6 flex flex-col items-center gap-6">
          <Image
            src={notFoundSvg}
            alt="Not Found"
            width={200}
            height={200}
            className="ml-10"
            priority
            data-testid={DataTestIdEnum.EMPTY_STATE_IMAGE}
          />
          <div className="space-y-4 text-center">
            <Typography variant={TypographyVariant.TITLE} className="text-3xl sm:text-3xl" data-testid={DataTestIdEnum.EMPTY_STATE_TITLE}>
              {title}
            </Typography>
            <Typography data-testid={DataTestIdEnum.EMPTY_STATE_DESCRITION}>{description}</Typography>
          </div>
          <div className="space-y-4 w-80">
            <Button asChild>
              <a href={button.href} data-testid={DataTestIdEnum.EMPTY_STATE_BUTTON}>
                {button.label}
              </a>
            </Button>
          </div>
        </Card>
      </ContentContainer>
    </div>
  );
}
